// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1W0Gx","errorLogs":"styles_errorLogs__3IpcZ"};